import S_base from '@/services/wasaapi/__base';

export default {
  async show(factoryId) {
    const res = await S_base.show({
      modelName: 'factory',
      modelId: factoryId,
    });
    return res;
  },
}